import Cookies from "universal-cookie";
import { createBrowserHistory } from "history";
import Api from "../helpers/Api";
import Constants from "../shared/constants/environmentConfig";
import { getAccountsDomain } from "../helpers/Utils";

const history = createBrowserHistory({
  forceRefresh: true,
});

const cookies = new Cookies();
export const UPDATE_AUTH = "Auth/SET_USER";
export const LOGOUT = "Auth/LOGOUT";

export const getUserTypes = () => async (dispatch) => {
  const response = await Api({
    method: "get",
    url: "/authentications/get_user_types",
  });
  if (response.success) {
    if (response.user_types.length) {
      const payload = {
        userDetails: response.user_details,
        userTypes: response.user_types,
        showSmsBalance: response.show_send_sms,
        isAdmin: response.is_admin,
        isAccountant: response.is_accountant,
      };
      dispatch({
        type: UPDATE_AUTH,
        payload,
      });
    }
  }
};

export function logout() {
  return (dispatch) => {
    Object.keys(cookies.getAll()).forEach((cookieName) => {
      cookies.remove(cookieName, {
        secure: Constants().cookie.secure,
        domain: Constants().cookie.domainRegex,
      });
      cookies.remove(cookieName, {
        path: "/",
        secure: Constants().cookie.secure,
      });
    });
    dispatch({
      type: LOGOUT,
    });
    const isServer = typeof window === "undefined";
    if (!isServer) {
      history.push(`${getAccountsDomain()}/logout`);
    }
  };
}
